import { useMemo } from "react"

import { useSearchspringSearchContext } from "@app/scripts/providers/searchspring"
import { useSearchspringOption } from "./use-searchspring-option"

// WARN: Only use this hook within a searchspring context that extends SearchspringSearchResponse

export function useSearchspringSort() {
  const { response } = useSearchspringSearchContext()

  const sorts = useMemo(() => {
    if (!response) return []

    return (
      response.sorting.options.map((option) => ({
        label: option.label,
        value: `${option.field}:${option.direction}`,
      })) ?? []
    )
  }, [response])

  const activeSort = useSearchspringOption("sort", {
    defaultValue: sorts[0]?.value,
    syncWithURL: true,
  })

  const activeSortLabel = useMemo(() => {
    const sort = sorts.find((sort) => sort.value === activeSort) ?? sorts[0]
    return sort?.label ?? ""
  }, [activeSort, sorts])

  return {
    sorts,
    activeSort,
    activeSortLabel,
  }
}
